import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, watch, shallowRef } from 'vue'
import { Chart, registerables, type ChartItem } from 'chart.js'


export default /*@__PURE__*/_defineComponent({
  __name: 'ChartBar',
  props: {
    data: {},
    chartOptions: {}
  },
  setup(__props: any) {

Chart.register(...registerables)

const props = __props

const chartRef = ref<HTMLCanvasElement | null>(null)
const chart = shallowRef<any>(null)

watch(
  () => props.data,
  (newData) => {
    if (chart.value) {
      chart.value.data = newData
      chart.value.update()
    } else if (chartRef.value) {
      chart.value = new Chart(chartRef.value, {
        type: 'bar',
        data: newData,
        options: props.chartOptions
      })
    }
  },
  { deep: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("canvas", {
    ref_key: "chartRef",
    ref: chartRef
  }, null, 512 /* NEED_PATCH */))
}
}

})